import { CheckmarkCircleFilledIcon, CheckmarkIcon, EditIcon } from '../../../../../icons';

export interface StepCardProps {
  title: string;
  tags: Array<string | number | undefined>;
  onClick?: () => void;
}

export const StepCard = ({ title, tags, onClick }: StepCardProps) => {
  return (
    <div className="h-6 p-4 flex justify-between items-center bg-grey-50 rounded-lg">
      <div className="flex gap-x-2">
        <CheckmarkCircleFilledIcon className="h-5 w-5 text-success-main" />
        {title}
      </div>
      <div className="flex gap-x-2 items-center ml-6">
        {tags
          .filter((tag) => tag !== undefined)
          .map((tag) => (
            <div
              key={tag}
              className="flex gap-x-1 items-center rounded-sm h-6 px-2 bg-heaven-200 text-sm text-heaven-600"
            >
              {tag}
              <CheckmarkIcon strokeWidth={1} className="h-4 w-4" />
            </div>
          ))}
        <EditIcon className="ml-4 p-0" onClick={onClick} />
      </div>
    </div>
  );
};
